// Legacy WebView support (old Android TV / projectors):
// - whatwg-fetch: Chrome <42 has no window.fetch (Android 5.1 WebView = Chrome 39)
// - resize-observer-polyfill: Chrome <64 lacks ResizeObserver (vendor libs reference it at module scope)
// - core-js/stable + intersection-observer: language + layout API polyfills
import 'whatwg-fetch';
import 'resize-observer-polyfill';
import 'core-js/stable';
import 'intersection-observer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Tell the inline boot watchdog (public/index.html) that the app mounted successfully.
// If this attribute never appears, the watchdog shows a readable error screen instead
// of an infinite black screen on old devices.
if (rootElement) rootElement.setAttribute('data-app-mounted', '1');
